"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { GlassStatusCard } from "@/components/ui/glass-status-card";
interface ErrorBoundaryProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
export default function LoginError({
  error,
  reset
}: ErrorBoundaryProps) {
  useEffect(() => {
    console.error("Login error boundary caught:", error);
    Sentry.captureException(error);
  }, [error]);
  return <GlassStatusCard hardNavigate eyebrow="Sign-in error" title="Login error" description="Something went wrong during login. Please try again." devDetail={process.env.NODE_ENV === "development" ? error.message : undefined} actions={[{
    label: "Try again",
    onClick: reset,
    variant: "primary"
  }, {
    label: "Back to home",
    href: "/",
    variant: "secondary"
  }]} data-sentry-element="GlassStatusCard" data-sentry-component="LoginError" data-sentry-source-file="error.tsx" />;
}